<template>
  <div
    :class="{
      'bg-gray-200': !rootCategories
    }"
    class="category-widget-header"
  >
    <div v-if="!rootCategories">
      <button
        v-show="isSelected"
        class="px-5 py-[25px]"
        @click="handleClickBack"
      >
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M15.8337 10H4.16699"
            stroke="black"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M10.0003 15.8346L4.16699 10.0013L10.0003 4.16797"
            stroke="black"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </button>
    </div>
    <h1
      v-if="rootCategories"
      class="text-[32px] font-bold ml-9 mt-5 mb-3"
    >
      {{ $t('header.menu.catalogTitle') }}
    </h1>
    <div
      v-else
      class="font-bold text-2xl truncate pr-4"
    >
      {{ category.name }}
    </div>
    <div />
  </div>
</template>

<script>
import isEmpty from 'es-toolkit/compat/isEmpty'
export default {
  props: {
    category: {
      type: Object,
      default () {
        return {}
      },
    },
    isSelected: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['back'],
  setup () {
    const searchForm = useSearchForm()
    return {
      city: searchForm.city,
      selectCategory: searchForm.selectCategory,
      hideCategoriesMenu: useGlobal().hideCategoriesMenu,
    }
  },
  computed: {
    rootCategories () {
      return isEmpty(this.category)
    },
  },
  methods: {
    handleClickBack () {
      this.$emit('back')
    },
    handleSelectCategory () {
      this.selectCategory(this.category)
      this.hideCategoriesMenu()
    },
  },
}
</script>

<style lang="sass" scoped>
  @use "sass:color"
  .category-widget-header
    @apply flex flex-row items-center

  .icon
    @apply flex justify-center items-center select-none cursor-pointer m-2
    z-index: 15

  $black: #000
  .black
    svg
      path
        stroke: $black
    &:hover
      svg
        path
          stroke: color.adjust($black, $lightness: 20%)
    &:active
      svg
        path
          stroke: color.adjust($black, $lightness: 30%)
</style>
